import React from "react";
import { SearchGroup } from "./SearchGroup";
import { SearchResults } from "./SearchResults";
import { SearchInput } from "./SearchInput";
import { useSearchContext } from "../../Contexts/SearchContext";
import "./SearchWidget.scss";

export const SearchWidget = (): JSX.Element => {
    const { groups } = useSearchContext();
    return (
        <div className="scrollable-content-container">
            {groups?.length ? (
                <>
                    <SearchGroup />
                    <SearchInput />
                    <SearchResults />
                </>
            ) : null}
        </div>
    );
};
